import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";

export const useInviteUser = () => {
  return useMutation({
    mutationFn: (data: {
      email: string;
      first_name: string;
      last_name: string;
      password: string;
      is_company_admin: boolean;
    }) =>
      apiClient.post(Routes.INVITE_USER, {
        invite_user: data,
      }),
  });
};
